import React from 'react';
import { FaCloudDownloadAlt, FaFileDownload } from 'react-icons/fa';

import { ButtonWithIcon } from '../../../components/ButtonWithIcon';
const ReactExport: any = require('react-export-excel-xlsx-fix');

const ExcelFile = ReactExport.modules.ExcelFile;
const ExcelSheet = ReactExport.modules.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.modules.ExcelFile.ExcelColumn;

export const ExcelExportUser = ({ data }: any): JSX.Element => {
    return (
        <ExcelFile
            element={
                <ButtonWithIcon
                    key={'btn'}
                    textId={'app.details_sub_program.export_users'}
                    icon={<FaCloudDownloadAlt />}
                />}>
            <ExcelSheet data={data} name="Sheet1">
                <ExcelColumn label="Email" value="email" />
                <ExcelColumn label="Status" value="status" />
            </ExcelSheet>
        </ExcelFile>
    );
}

export const ExcelExportUserProgram = ({ data }: any): JSX.Element => {
    return (
        <ExcelFile
            element={
                <FaFileDownload
                    style={styles.iconFile}
                    size={20}
                />}>
            <ExcelSheet data={data} name="Sheet1">
                <ExcelColumn label="Program" value="program" />
                <ExcelColumn label="SubProgram" value="subProgram" />
                <ExcelColumn label="Email" value="email" />
                <ExcelColumn label="Status" value="status" />
                <ExcelColumn label="DueDate" value="dueDate" />
            </ExcelSheet>
        </ExcelFile>
    );
}

const styles = {
    iconFile: {
        marginRight: 5,
        marginTop: 2
    } as React.CSSProperties,
}
